import { toDateTimeString } from '~components/CompliancePanel/compliancePanelUtils';

import { StagedComplianceDoc } from './checklist';
import { ComplianceDocument, CompliantType } from './models';

export async function createStagedComplianceDocuments(
  compliantType: CompliantType,
  compliantId: string,
  stagedDocs: StagedComplianceDoc[],
  createDocument: (
    type: CompliantType,
    id: string,
    body: Record<string, unknown>,
  ) => Promise<ComplianceDocument>,
  createFileAttachment: (file: File, documentId: string) => Promise<unknown>,
): Promise<{ failed: number }> {
  let failed = 0;

  for (const doc of stagedDocs) {
    try {
      const created = await createDocument(compliantType, compliantId, {
        compliance_document_type_id: doc.documentTypeId,
        value: doc.value,
        expires_at: toDateTimeString(doc.expiresAt),
      });
      if (doc.file && created?.id) {
        await createFileAttachment(doc.file, created.id);
      }
    } catch {
      failed++;
    }
  }

  return { failed };
}
